export enum NewJobPositions {
  Pfk = 'PFK',
  PfkDnw = 'PFK-DNW',
  GuK = 'GuK',
  GuKi = 'GuKi',
  HkD1 = 'HK D1',
  HkD2 = 'HK D2',
  HkD3 = 'HK D3',
  HkF = 'HK F',
  GuKh = 'GuKh',
  Btk = 'BTK',
  Pdl = 'PDL',
  StellvPdl = 'stellv. PDL',
  Wbl = 'WBL',
  StellvWbl = 'stellv. WBL',
  Pa = 'PA',
  StellvPa = 'stellv. PA',
  Qb = 'QB',
  Wm = 'WM',
  Tl = 'TL',
  StellvTl = 'stellv. TL',
  Rl = 'RL',
  El = 'EL',
  StellvEl = 'stellv. EL',
  Pd = 'PD',
  StellvPd = 'stellv. PD',
  Sl = 'SL',
  StellvSl = 'stellv. SL',
  GerontoFk = 'Geronto-FK',
  PalliativFk = 'Palliativ-FK',
  HygieneFk = 'Hygiene-FK',
  Ata = 'ATA',
  Cta = 'CTA',
  Mfa = 'MFA',
  Mta = 'MTA',
  Mtra = 'MTRA',
  Ota = 'OTA',
  Pta = 'PTA',
  Hep = 'HEP',
  Heph = 'HEPH',
  Lsb = 'LSB (Leitung Soziale Betreuung)',
  Sonst = 'Sonst',
}
